var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-rack',{staticClass:"pa-0",attrs:{"column":""}},[_c('i-section',{attrs:{"scrollable":false}},[_c('iframe',{staticClass:"showcase-frame",attrs:{"src":"https://amgen.showcase-app.io/#/auth/login"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }